<!-- 推广工具 -->
<template>
  <div class="basicStyle" v-loading="loading">
    <div class="contLeft">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-if="senioriupShow" label="招生宝小程序" name="first">
          <div class="firstBox">
            <div class="title">
              使用招生宝小程序推广-操作流程
            </div>
            <iframe
              :src="firstSrc"
              :width="firstWidth"
              :height="firstHeight"
              frameborder="0"
              allowfullscreen
              />
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="senioriupShow" label="PC网站" name="second">
          <div class="secondBox">
            <img class="img" src="../../assets/new/tj_a11.png" alt="" />
          </div>
          <div class="secondBtn">
            <div class="btn1" @click="btn1">查看网站</div>
            <div class="btn2" @click="btn2">复制分享链接</div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="招生表单" name="third">
          <div class="thirdBox">
            <div class="title">
              H5招生推广链接
            </div>
            <div class="cont" v-if="promotionData && promotionData.images">
              <div class="thirdItem">
                <img class="img" :src="promotionData.images[0].image" alt="" />
                <div  class="itemDetail">
                  <div class="itemTitle">{{promotionData.images[0].title}}</div>
                  <div class="itemCont">{{promotionData.images[0].content}}</div>
                  <div class="itemBtn">
                    <div class="btn1" @click="copyLink(0)">复制链接</div>
                    <div class="btn2" @click="savePic(0)">保存图片</div>
                    <div class="btn3" @click="preview(0)">预览</div>
                  </div>
                </div>
              </div>
              <div class="thirdItem" v-if="category=='senioriup'">
                <img class="img" :src="promotionData.images[1].image" alt="" />
                <div  class="itemDetail">
                  <div class="itemTitle">{{promotionData.images[1].title}} <span class="cksj" @click="cksj">查看报名数据</span></div>
                  <div class="itemCont">{{promotionData.images[1].content}}</div>
                  <div class="itemBtn">
                    <div class="btn1" @click="copyLink(1)">复制链接</div>
                    <div class="btn2" @click="savePic(1)">保存图片</div>
                    <div class="btn3" @click="preview(1)">预览</div>
                  </div>
                </div>
              </div>
              <div class="thirdItem" v-if="category=='senioriup'">
                <img class="img" :src="promotionData.images[2].image" alt="" />
                <div  class="itemDetail">
                  <div class="itemTitle">{{promotionData.images[2].title}}</div>
                  <div class="itemCont">{{promotionData.images[2].content}}</div>
                  <div class="itemBtn">
                    <div class="btn1" @click="copyLink(2)">复制链接</div>
                    <div class="btn2" @click="savePic(2)">保存图片</div>
                    <div class="btn3" @click="preview(2)">预览</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </el-tab-pane>

        <el-tab-pane label="朋友圈海报/文案" name="fourth">
           
          <div class="fourthBox">  
            <div class="posterList">
               <div class="posterItem" v-for="(item, index) in posterList"
                  :key="index"  
                  @click="posterClick(item)"
                  >
                  <img 
                    style="width: 100%; " 
                    :src="item.img_url" 
                  />  
               </div> 
            </div>
            <div class="pagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryInfo.page"
                :page-sizes="[12, 24, 36, 48]"
                :page-size="queryInfo.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              >
              </el-pagination>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>  
      <div v-if="activeName=='third'" class="categoryBox">
        <span>考试类别</span>
        <el-select
          v-model="category"
          filterable
          placeholder="请选择考试类别"
          :clearable="true"
          size="mini"
          @change="categoryChange"
        >
          <el-option
            v-for="item in categoryOptions"
            :key="item.app_key"
            :label="item.app_key_name"
            :value="item.app_key"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="contRight">
      <div class="rightBox">
        <div v-if="activeName=='first'">
          <div class="title">扫码进入招生宝小程序</div>
          <img class="img" src="../../assets/new/tj_a9.png" alt="" />
          <div class="cont">
            机构员工使用请注意: </br>
            需要先将员工信息录入到【员工管理】列表，员工才可以正常登录使用
          </div>
        </div>
        <div v-show="activeName=='second'">
          <iframe
              :src="secondExplain"
              :width="secondWidth"
              :height="secondHeight"
              frameborder="0"
              allowfullscreen
              />
        </div>
        <div v-show="activeName=='third'">
          <iframe
              :src="thirdExplain"
              :width="thirdWidth"
              :height="thirdHeight"
              frameborder="0"
              allowfullscreen 
              /> 
        </div> 
        <div v-show="activeName=='fourth'">
          <iframe
              :src="fourthExplain"
              :width="fourthWidth"
              :height="fourthHeight"
              frameborder="0"
              allowfullscreen
              />  
        </div>


      </div>
    </div>
    <el-dialog title="预览" :visible.sync="dialogVisible" width="415px">
      <div class="top-h1">
        <!-- <div v-if="app_product_name" class="text">{{ app_product_name }}</div> -->
        <img
          v-if="intro_img_list && intro_img_list.length > 0"
          class="img"
          :src="intro_img_list[0]"
        />
      </div>
      <div class="top-h2">
        <div class="top-h2-box">
          <img v-if="intro_img_list" class="img" :src="intro_img_list[1]" />

          <div class="int1Box">
            <input
              disabled
              placeholder="请输入手机号"
              maxlength="11"
              type="tel"
            />
          </div>
          <div class="int2Box">
            <input
              disabled
              placeholder="请输入验证码"
              maxlength="4"
              type="text"
            />
            <div class="btn">获取短信验证码</div>
          </div>
          <div class="int3Box">
            <img class="img" src="../../assets/img/tobpic10.png" />
          </div>
        </div>
      </div>
      <div v-if="intro_img_list && intro_img_list[2]" class="top-h3">
        <img
          v-if="intro_img_list && intro_img_list.length > 0"
          class="img"
          :src="intro_img_list[2]"
        />
      </div>
      <div v-if="intro_img_list && intro_img_list[3]" class="top-h3">
        <img
          v-if="intro_img_list && intro_img_list.length > 0"
          class="img"
          :src="intro_img_list[3]"
        />
      </div>
      <div v-if="recruitData.about" class="top-h4">
        <img v-if="intro_img_list" class="title" :src="intro_img_list[4]" />
        <div class="cont">
          {{ recruitData.about }}
        </div>
      </div>
      <div class="top-h5">
        <img v-if="intro_img_list" class="title" :src="intro_img_list[5]" />
        <div class="cont">
          <div
            v-if="recruitData.name"
            class="contItem1"
            style="padding-bottom: 10px"
          >
            <img class="pic" src="../../assets/img/tobpic7.png" />
            <span class="text">{{ recruitData.name }}</span>
          </div>
          <div
            v-if="recruitData.mobile"
            class="contItem2"
            style="padding-bottom: 10px"
          >
            <div class="itemLeft">
              <img class="pic" src="../../assets/img/tobpic8.png" />
              <span class="text">{{ recruitData.mobile }}</span>
            </div>
            <div class="itemRight" @click="callPhone(recruitData.mobile)">
              拨号
            </div>
          </div>
          <div v-if="recruitData.address" class="contItem1">
            <img class="pic" src="../../assets/img/tobpic9.png" />
            <span class="text">{{ recruitData.address }}</span>
          </div>
        </div>
        <div v-if="recruitData.wechat_code" class="wx-title">
          <img class="pic" src="../../assets/img/tobpic16.png" />
          长按识别二维码添加微信
          <img class="pic" src="../../assets/img/tobpic16.png" />
        </div>
        <div v-if="recruitData.wechat_code" class="wx-img">
          <img class="img" :src="recruitData.wechat_code" />
        </div>
      </div>
      <div class="wx-submit">
        <div class="submit">立即领取</div>
      </div>
 
    </el-dialog>
    <el-dialog :visible.sync="posterEditorVisible" width="415px"> 
      <div class="posterBox">
        <div class="posterCont_h1" ref="posterCont" id="posterCont"> 
          <div style="position:relative; ">
              <img 
              class="pic1"
              v-if="posterEditorData&&posterEditorData.poster&&posterEditorData.poster.img_url" 
              :src="posterEditorData.poster.img_url + '?is_ok'" crossorigin="Anonymous" 
                /> 
              <div class="h1_cont">
                <div style="padding: 20px;
                      display: flex;
                      flex-wrap: wrap;
                      justify-content: flex-start;
                      align-items: center;"> 
                  <div class="picEdit" v-if="convert_type==1">    
                    <el-upload
                      action="#"
                      class="avatar-uploader"
                      accept="gif,bmp,jpg,jpeg,png"
                      :show-file-list="false"
                      :multiple="false"
                      :auto-upload="false"
                      :on-change="
                        (file, fileList) => {
                          handleAvatarSuccess(file, fileList);
                        }
                      "
                    >
                      <img class="pic2" v-if="posterEditorData.wechat_code" :src="posterEditorData.wechat_code + '?is_ok'"  crossorigin="Anonymous" />
                      <i v-else class="el-icon-plus" />
                    </el-upload>
                  </div>

                  <div class="qrCodeEdit" v-else>
                    <qrCodeEdit :id="convert_type_name" :codeUrl="zs_url"></qrCodeEdit>
                  </div>

                  <div class="cont_r" @click="phoneClick">
                    <i class="el-icon-phone"
                      style="   
                      display: block;  "></i>
                    <span class="phone">{{posterEditorData.phone}}</span> 
                  </div>
                </div>
                </div>  
          </div>
        </div>
        <div class="posterCont_h2">
          <i class="el-icon-caret-bottom" 
            style="   
            display: block;
            text-align: center;"></i>
          <div class="h2_title">请选择海报转化路径</div>
          <div class="h2_cont"> 
            <div class="h2_item" 
              v-for="item in posterEditorData.convert_type_list"
              :key="item.convert_type"
              :class="item.act ? 'act' : ''"
              @click="convertClick(item)"
              >
              <div class="item_title">{{item.convert_type_name}}</div> 
              <div class="item_cont">{{item.desc}}</div>
            </div>
          </div>
        </div>
        <div class="posterCont_h3">
          <el-button type="primary" :loading="posterLoading" @click="savePoster()">保存海报</el-button>
        </div>

        <div class="posterCont_h4" v-if="phoneShow">  
          <div class="phoneBox_h1"> 
              <div class="btnl" @click="phoneClose()">取消</div>
              <div class="btnNane">修改电话</div>
              <div class="btnr" @click="phoneConfirm()">确定</div> 
          </div>
          <div class="phoneBox_h2">
            <i class="el-icon-phone"
              style="display: block;"></i>
            <el-input @input="$forceUpdate()" v-model="newPhone" placeholder="请输入电话号码" ></el-input> 
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import studentApi from "@/api/student.js";
import goodsApi from "@/api/goods.js";
import TableComponents from "@/components/TableComponents.vue";
import commonApi from "@/api/common.js";
import financialApi from "@/api/financial.js";
import Clipboard from "clipboard";
import { clearObj, copyToClip, deepClone } from "@/utils/index.js"; 
import OSS from "ali-oss";
import qrCodeEdit from "@/components/qrCodeEdit.vue";
import html2canvas from "html2canvas"; 
export default {
  name: "ExtendTool",
  components: { qrCodeEdit },
  data() {
    return {
      activeName: "first",
      firstSrc:'',
      firstWidth:'100%',
      firstHeight:'800px',
      thirdExplain:'',
      secondExplain:"",
      secondWidth:'100%',
      secondHeight:'400px',
      thirdWidth:'100%',
      thirdHeight:'400px',
      fourthWidth:'100%',
      fourthHeight:'400px',
      fourthExplain:'',
      ggzhiff_text_name:'',
      ggzhiff_text_cont:'',
      bmbd_text_name:'',
      bmbd_text_cont:'',
      zjff_text_name:'',
      zjff_text_cont:'',
      senioriup:'',
      senioriupcollegexcu1:'',
      senioriupllegexcu2:'',
      categoryOptions:[
        // { key: "adultscollege", value: "成考" },
        // { key: "senioriup", value: "高职单招" },
      ],
      category:"",
      promotionData:{},
      dialogVisible:false,
      previewSrc:"",
      previewWidth:'100%',
      previewHeight:'400px',
      intro_img_list:[],
      loading:false,
      senioriupShow:false,
      // adultscollegeShow:false,
      app_keys:"",
      recruitData:{},
      queryInfo:{
        app_key:'senioriup',
        limit:12,
        page:1,
      },
      total:0,
      posterList:[],
      posterEditorVisible:false,
      posterEditorData:{},
      // OSS阿里云上传配置信息
      keysArr: {
        AccessKeySecret: "axa8TvZsnh7TPt84P9h3ExcBKNH8H2",
        AccessKeyId: "LTAI5tKbL1F137o429peV8bY",
        UrlHeader: "https://img2.meite.com/",
        Expiration: "",
        SecurityToken: "",
      },
      convert_type:1,
      convert_type_name:"",
      zs_url:"https://www.baidu.com",
      uploadfile:{},
      posterLoading:false,
      phoneShow:false,
      newPhone:""
    };
  },
  created() {
    console.log(process.env.NODE_ENV)
    if (process.env.NODE_ENV === 'development') {
      this.firstSrc = 'http://testLavaMobile.qbting.com/testtask/#/web?key=beikaotongPromotionOperationProcess&apptype=beikaotong'
      this.thirdExplain = 'http://testLavaMobile.qbting.com/testtask/#/web?key=beikaotongenrollmentform&apptype=beikaotong'
      this.secondExplain = "http://testLavaMobile.qbting.com/testtask/#/web?key=beikaotongPCwebsiteinstructions&apptype=beikaotong"
      this.fourthExplain = "http://testLavaMobile.qbting.com/testtask/#/web?key=beikaotonglogosmsmsm&apptype=beikaotong"
    } else {
      this.firstSrc = 'http://qmb.meite.com/task/#/web?key=beikaotongPromotionOperationProcess&apptype=beikaotong'
      this.thirdExplain = 'http://qmb.meite.com/task/#/web?key=beikaotongenrollmentform&apptype=beikaotong'
      this.secondExplain = "http://qmb.meite.com/task/#/web?key=beikaotongPCwebsiteinstructions&apptype=beikaotong"
      this.fourthExplain = "http://qmb.meite.com/testtask/#/web?key=beikaotonglogosmsmsm&apptype=beikaotong"
    }
    this.getDic()
    this.homeList()
    this.getMe()
    this.getTobPosterList()
  },
  methods: {
    phoneClose(){
      this.phoneShow = false;
    },
    phoneConfirm(){
      this.posterEditorData.phone = this.newPhone;
      this.phoneShow = false;
    },
    phoneClick(){
      // 电话号码修改
      this.newPhone = this.posterEditorData.phone;
      this.phoneShow = true;
    },
    createPoster() {
      // 生成海报
      let dom = this.$refs["posterCont"];
      html2canvas(dom, {
        width: dom.clientWidth, // 生成图片的宽度
        height: dom.clientHeight, // 生成图片的高度
        scale: 9, //scale 将其调大可以解决低分辨率设备下生成的图片模糊问题
        useCORS: true, // 是否允许跨域 如果不行在img标签增加 crossOrigin="Anonymous" 属性 
      }).then((canvas) => {
        // 生成一个base64的图片路径
        let dataURL = canvas.toDataURL("image/png");
        let myName = `${this.getFileName(
          16
        )}`; 
        console.log("111", dataURL);
        this.downloadFile(dataURL, myName);
      });
    },
    downloadFile(url, name) {
      const a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", name);
      a.setAttribute("target", "_blank");
      const clickEvent = document.createEvent("MouseEvents");
      clickEvent.initEvent("click", true, true);
      a.dispatchEvent(clickEvent);
      
      this.posterLoading = false;
      this.posterEditorVisible = false; 
      this.queryInfo.page = 1;
      this.getTobPosterList()
      this.$message({
        message: "保存成功!",
        type: "success", 
      });
    },

    savePoster(){
      this.posterLoading = true;
      console.log('savePoster',this.posterEditorData) 
      this.createPoster()

      var postData = {
        poster_id:this.posterEditorData.poster.id,
        convert_type:this.convert_type,
        phone:this.posterEditorData.phone,
        qrcode:this.posterEditorData.wechat_code,
      }
      console.log('postData---',postData)
      return 
      // commonApi.tobPosterSave(postData).then((res) => { 
      //   if (res.code == 200) {
      //     this.posterEditorVisible = false; 
      //     this.queryInfo.page = 1;
      //     this.getTobPosterList()
      //     this.$message({
      //       message: "保存成功!",
      //       type: "success", 
      //     });
      //   }
      // }) 
    }, 
    // 获取年月Fn
    getDate() {
      const date = new Date();
      const year = String(date.getFullYear());
      const month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      return year + month;
    },
    // 获取随机文件名称
    getFileName(length) {
      const data = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
      ];
      let nums = "";
      for (let i = 0; i < length; i++) {
        const r = parseInt(Math.random() * 61, 10);
        nums += data[r];
      }
      return nums;
    },
    // 处理广告图片的上传
    handleAvatarSuccess(res, file) {
      // this.coverAdUpstatus = true;
      let limitSize = res.size / 1024 / 1024;
      let type = res.raw.type;
      let upType = res.raw.type.split("/").pop();
      if (
        (limitSize < 2 && type == "image/jpeg") ||
        type == "image/png" ||
        type == "image/jpg"
      ) {
        let name = `questions/${this.getDate()}/${this.getFileName(
          16
        )}.${upType}`; 
        this.FileUpload("ad", name, res.raw);
      } else {
        this.$message({
          type: "error",
          showClose: true,
          message: "只能上传jpeg、jpg或png文件，且大小不超过2M",
        });
        // this.coverAdUpstatus = false;
      }
    },
    // 图片上传
    FileUpload(type, name, file ) {
      console.log('FileUpload1',type, name, file)
      var client = new OSS({
        region: "oss-cn-hangzhou",
        // endpoint: 'oss-cn-hangzhou',
        accessKeyId: this.keysArr.AccessKeyId,
        accessKeySecret: this.keysArr.AccessKeySecret,
        // bucket: 'meitetest',
        bucket: "meitetest",
      });
      client
        .put(name, file)
        .then((res) => {
          this.uploadfile = [
            {
              url: `${this.keysArr.UrlHeader}${res.name}`,
              name: res.name,
            },
          ]; 
          this.posterEditorData.wechat_code = this.uploadfile[0].url; 
          this.$forceUpdate() //刷新
          console.log('FileUpload2',this.uploadfile[0].url)
          this.$message({
            message: "上传成功!",
            type: "success",
            showClose: true,
          });
        })
        .catch((err) => {
          //  err);
        });
    },
    convertClick(e){
      console.log('convertClick',e) 
      this.convert_type = e.convert_type
      this.convert_type_name = e.convert_type_name
      this.zs_url = e.zs_url
 
      this.posterEditorData.convert_type_list.forEach((item,index) => {
        item.act = false
        if(item.convert_type==e.convert_type){
          item.act = true
        }
      })
      this.$forceUpdate() //刷新
    },
    posterClick(e){
      // 点击海报 
      commonApi.getTobPosterInfo({id:e.id}).then((res) => { 
        if (res.code == 200) {
          this.posterEditorData = res.data
          console.log('getTobPosterInfo',this.posterEditorData)
          this.posterEditorData.phone = res.data.user_poster.phone
          this.posterEditorData.wechat_code = res.data.group.wechat_code
 
          this.posterEditorData.convert_type_list.forEach((item,index) => {
            item.act = false
            if(item.convert_type==res.data.user_poster.convert_type){
              item.act = true 
              
              if(res.data.user_poster.convert_type!=1){
                this.convert_type_name=item.convert_type_name
                this.zs_url=item.zs_url
              }
            }
          })
          this.convert_type = res.data.user_poster.convert_type
          this.posterEditorVisible = true 
        }
      })
    }, 
    // 分页
    handleSizeChange(e){ 
      this.queryInfo.limit = e
      this.getTobPosterList()
    },
    handleCurrentChange(e){
      this.queryInfo.page = e
      this.getTobPosterList()
    },
    getTobPosterList(){ 
      var query = deepClone(this.queryInfo);
      commonApi.getTobPosterList(query).then((res) => { 
        if (res.code == 200) {
          console.log('getTobPosterList',res.data.list.data)
          this.posterList = res.data.list.data
          this.total = res.data.list.total
        }
      })
    },
    async homeList() {
      const res = await commonApi.homeData({ app_keys: this.app_keys });
      if (res.code == 200) {
        this.categoryOptions = res.data.menu;
        this.senioriupShow = false;
        this.adultscollegeShow = false;
        for(let i=0;i<res.data.menu.length;i++){
          if (res.data.menu[i].app_key == "senioriup") {
            // 高职单招
            this.senioriupShow = true;
            this.activeName ='first'
          }else{
            this.activeName ='third'
          }
          if (res.data.menu[i].app_key == "adultscollege") {
            // 成考
            this.adultscollegeShow = true;
          }
        }

        
        if(this.$route.query.activeName){
          this.activeName = this.$route.query.activeName
        }

        if(this.senioriupShow){
          this.category = 'senioriup'
        }else{
          this.category = 'adultscollege'
        }
        console.log('categoryOptions',res.data.menu)

        this.getPromotion()


      }
    },
    cksj(){
      this.$router.push({
        path: "/recruitStudentTable",
        // query: {
        //   recordId: recordId,
        // },
      });
    },
    categoryChange(e){
      console.log('categoryChange',e)
      this.getPromotion()
    },
    getPromotion(){
      goodsApi.getPromotion({tag:'beikaotongenrollmentform', app_key:this.category}).then((res) => {
        if (res.code === 200) {
          this.promotionData = res.data
          console.log("getPromotion--", this.promotionData );
          this.intro_img_list = res.data.images[0].intro_img_list
          this.recruitData = res.data.group
        }
      });

      // goodsApi.getPromotion({tag:'beikaotongenrollmentform', app_key:"senioriup"}).then((res) => {
      //   if (res.code === 200) {
      //     this.promotionData = res.data
      //     console.log("getPromotion--2", res.data );
      //   }
      // });
    },
    preview(e){
      if(e==0){
        this.dialogVisible = true;
      }else{
        window.open(this.promotionData.images[e].preview_url, '_blank');
      }
    },
    copyLink(e) {
      this.$message.success("复制成功");
      var share_img_url = this.promotionData.images[e].url;
      copyToClip(share_img_url);
    },
    async savePic(e) {
      console.log("savePic", this.promotionData);
      this.loading = true;
      var share_link = this.promotionData.images[e].url
      var share_bg_img = this.promotionData.images[e].image
      const res = await financialApi.tobShareImg({
        share_link: share_link,
        share_bg_img: share_bg_img,
      });
      if (res.code == 200) {
        this.downloadByBlob(res.data.share_img_url, res.data.share_img_url);
      }
    },
    downloadByBlob(url, name) {
      console.log("downloadByBlob", url, name);
      const downloadRes = async (url, name) => {
        // console.log("run downloadRes",objectUrl,name);
        let response = await fetch(url);
        // 内容转变成blob地址
        let blob = await response.blob();
        // 创建隐藏的可下载链接
        let objectUrl = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        //地址
        a.href = objectUrl;
        //修改文件名
        a.download = name;
        // 触发点击
        document.body.appendChild(a);
        a.click();
        //移除
        setTimeout(() => document.body.removeChild(a), 1000);
        this.loading = false;
      };
      downloadRes(url, name);
    },
    getDic() {
      commonApi.getInfoToName({ name: "bktzkbzkbText" }).then((res) => {
        res.data.forEach((item) => {
          if(item.key=='ggzhiff_text'){
            this.ggzhiff_text_name = item.value.split('/')[0]
            this.ggzhiff_text_cont = item.value.split('/')[1];
          }
          if(item.key=='bmbd_text'){
            this.bmbd_text_name = item.value.split('/')[0]
            this.bmbd_text_cont = item.value.split('/')[1];
          }
          if(item.key=='zjff_text'){
            this.zjff_text_name = item.value.split('/')[0]
            this.zjff_text_cont = item.value.split('/')[1];
          }

        })
      });
      commonApi.getInfoToName({ name: "bktsharemage" }).then((res) => {
        res.data.forEach((item) => {
          if(item.key=='senioriup'){
            this.senioriup = item.value
          }
          if(item.key=='senioriupcollegexcu1'){
            this.senioriupcollegexcu1 = item.value
          }
          if(item.key=='senioriupllegexcu2'){
            this.senioriupllegexcu2 = item.value
          }

        })
      });
    },

    handleClick(tab, event){
      console.log('handleClick',tab, event);
    },
    btn1(){
      // 查看网站
      window.open(this.domain, '_blank');
    },
    btn2(){
      var url = this.domain;
      this.$message.success("复制成功");
      copyToClip(url);
    },
    async getMe() {
      const res = await commonApi.tobMe();
      if (res.code === 200) {
        this.domain = res.data.group.domain
      }
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  width: 100%;
  padding: 16px 32px 16px 16px;
  box-sizing: border-box;
  overflow: auto;
  display: flex;
  justify-content: space-between;
  min-width: 1600px;
  background: #f7f8fb;
  .contLeft {
    width: 73%;
    min-width: 952px;
    display: block;
    background: #fff;
    border-radius: 8px;
    padding: 30px 26px;
    height: fit-content;
    position: relative;
    .firstBox{
      .title{
        font-size: 18px;
        font-weight: 600;
        color: #302C3D;
        text-align: center;
        margin: 20px 0;
      }
      .img{
        display: block;
        margin:0 auto;
        width: 100%;
      }
    }
    .secondBox{
      background: #F7F8FB;
      padding:80px 0 50px 0;

      .img{
        width: 650px;
        height: 352px;
        display: block;
        margin: 0 auto;
      }
    }
    .secondBtn{
      display: block;
      text-align:center;
      font-size: 18px;
      font-weight: 600;
      color: #FFFFFF;
      margin-top:40px;
      .btn1{
        display: inline-block;
        width: 180px;
        height: 56px;
        line-height: 56px;
        background: #00C793;
        border-radius: 8px;
        margin-right:30px;
        cursor: pointer;
      }
      .btn2{
        display: inline-block;
        width: 180px;
        height: 56px;
        line-height: 56px;
        text-align:center;
        background: #846FFD;
        border-radius: 8px;
        margin-right:30px;
        cursor: pointer;
      }
    }
    .thirdBox{
      .title{
        text-align: center;
        margin: 20px 0;
        font-size: 18px;
        font-weight: 600;
        color: #302C3D;
      }
      .cont{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        .thirdItem{
          display: block;
          width:300px;
          height: 620px;
          position: relative;
          .img{
              width:300px;
              height:465px;
          }
          .itemDetail{
            padding: 25px 17px;
            background: #F7F8FB;
            border-radius: 8px;
            opacity: 10;
            position: absolute;
            bottom:0;
            left:0;
            width: 266px;
            .itemTitle{
              font-size: 17px;
              color: #191B27;

              .cksj{
                line-height: 22px;
                background: #FFFFFF;
                border-radius: 4px 4px 4px 4px;
                font-size: 12px;
                color: #465069;
                display: block;
                float: right;
                padding: 0 20px;
                cursor:pointer;
              }
            }
            .itemCont{
              font-size: 15px;
              color: #465069;
              margin-top: 10px;
              min-height: 40px;
            }
            .itemBtn{
              display: flex;
              flex-wrap: wrap;
              text-align: center;
              margin-top: 40px;
              .btn1{
                width: 82px;
                height: 36px;
                line-height:36px;
                border-radius: 8px;
                font-size: 14px;
                color: #FFFFFF;
                background: linear-gradient(234deg, #9583FF 0%, #7057FF 100%);
                margin-right: 8px;
                cursor: pointer;

              }
              .btn2{
                width: 82px;
                height: 36px;
                line-height:36px;
                border-radius: 8px;
                font-size: 14px;
                color: #FFFFFF;
                background: #00C793;
                margin-right: 8px;
                cursor: pointer;
              }
              .btn3{
                width: 82px;
                height: 34px;
                line-height:36px;
                border-radius: 8px;
                font-size: 14px;
                color: #846FFD;
                border: 1px solid #7861FF;
                cursor: pointer;
              }

            }
          }
        }
      }
    }

    .categoryBox{
      position: absolute;
      right: 30px;
      top: 26px;
      span{
        margin-right:20px;
      }
    }
  }
  .contRight {
    width: 22%;
    min-width: 340px;
    display: block;
    border-radius: 8px;
      background: #fff;

    .rightBox {
      background: #fff;
      padding: 30px 26px;
      .title {
        font-size: 18px;
        color: #191b27;
        border-bottom: 1px solid #e7eaf0;
        padding-bottom: 22px;
      }
      .img {
        width: 188px;
        height: 188px;
        display: block;
        margin: 0 auto;
        padding-top: 50px;
        padding-bottom: 38px;
      }
      .cont {
        font-size: 14px;
        color: #465069;
        line-height: 160%;
      }
    }
  }


.top-h1 {
  display: block;
  position: relative;
  .text {
    position: absolute;
    left: 0;
    top: 16px;
    font-size: 18px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin-left: 25px;
  }
  .img {
    display: block;
    width: 100%;
  }
  .logo {
    display: block;
    width: 120px;
    height: 54px;
    position: absolute;
    right: 0;
    top: 13px;
    padding: 5px 3px 5px 12px;
    background-color: #fff;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
  }
}

.top-h2 {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  box-shadow: 0px -4px 20px 0px rgba(172, 159, 255, 0.3);
  margin-top: -20px;
  background-color: #fff;
  z-index: 1;
  position: relative;
  .top-h2-box {
    padding: 25px 25px 0 25px;
    .img {
      width: 135px;
      display: block;
      margin: 0 auto;
      padding-bottom: 20px;
    }
    .int1Box {
      padding-bottom: 20px;
      input,
      .input {
        width: calc(100% - 48px);
        height: 46px;
        padding: 0 24px 0 24px;
        background: #f7f8fb;
        border-radius: 280px;
        border: none;
        opacity: 1;
      }
    }
    .int2Box {
      position: relative;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      border-radius: 4px;
      overflow: hidden;
      background: #f7f8fb;
      padding: 0 24px;
      height: 46px;
      border-radius: 280px;
      margin-bottom: 22px;
      input,
      .input {
        position: relative;
        width: 60%;
        height: 100%;
        box-sizing: border-box;
        padding: 0 9px;
        font-size: 13px;
        line-height: 100%;
        background: #f7f8fb;
        border: none;
        &.invalid,
        &::-webkit-input-placeholder {
          color: #999fb5;
        }
        &.alignRight {
          text-align: right;
        }
        .arrows {
          position: absolute;
          top: 0;
          right: 10px;
        }
      }
      .shape,
      .btn,
      .mask {
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
        line-height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .shape {
        right: 10px;
        color: #999fb5;
      }
      .btn {
        right: 24px;
        width: 100px;
        font-size: 13px;
        font-family: "PingFang SC-常规体", "PingFang SC";
        color: #5659dd;
        &.invalid {
          color: #999fb5;
          width: auto;
          padding: 0 10px;
        }
      }
      .mask {
        width: 100%;
        opacity: 0;
        z-index: 9;
      }
      & + .inp {
        margin-left: 10px;
      }
    }
    .int3Box {
      display: block;
      .img {
        display: block;
        width: 100%;
      }
    }
  }
}

.top-h3 {
  display: block;
  .img {
    display: block;
    width: 100%;
  }
}
.top-h4 {
  padding-top: 28px;
  background: url(../../assets/img/tobpic13.png) no-repeat;
  background-size: 100% auto;
  .title {
    display: block;
    margin: 0 auto;
    width: 150px;
  }
  .cont {
    padding: 32px 29px 42px 29px;
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #465069;
    line-height: 28px;
    // min-height: 200px;
  }
}

.top-h5 {
  padding-top: 28px;
  padding-bottom: 36px;
  padding-left: 26px;
  padding-right: 26px;
  padding-top: 26px;
  background: url(../../assets/img/tobpic15.png) no-repeat;
  background-size: 100% auto;
  .title {
    display: block;
    margin: 0 auto;
    width: 150px;
    padding-bottom: 36px;
  }
  .cont {
    padding: 16px 19px;
    background-color: #fff;
    box-shadow: 0px 5px 18px 0px rgba(234, 218, 255, 0.6554);
    border-radius: 19px;
    .contItem1 {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .pic {
        display: inline-block;
        width: 17px;
        height: 17px;
        vertical-align: middle;
        margin-right: 10px;
      }
      .text {
        display: inline-block;
        font-size: 15px;
        font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
        font-weight: 400;
        color: #465069;
        line-height: 17px;
        width: 80%;
        vertical-align: middle;
      }
    }
    .contItem2 {
      display: flex;
      justify-content: space-between;
      .itemLeft {
        width: 70%;
        .pic {
          display: inline-block;
          width: 17px;
          vertical-align: middle;
          margin-right: 10px;
        }
        .text {
          display: inline-block;
          font-size: 15px;
          font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
          font-weight: 400;
          color: #465069;
          line-height: 15px;
          width: 60%;
          vertical-align: middle;
        }
      }

      .itemRight {
        background: #ff7f3b;
        box-shadow: 0px 0px 12px 0px rgba(91, 37, 240, 0.1);
        border-radius: 50px;
        font-size: 13px;
        font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
        font-weight: 400;
        color: #ffffff;
        line-height: 100%;
        padding: 5px 11px;
      }
    }
  }

  .wx-title {
    font-size: 17px;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: 400;
    color: #ff7c39;
    line-height: 100%;
    text-align: center;
    padding: 26px 0 20px 0;
    .pic {
      display: inline-block;
      width: 8px;
      vertical-align: middle;
      margin: 0 4px;
    }
  }
  .wx-img {
    width: 163px;
    height: 163px;
    margin: 0 auto;
    .img {
      width: 100%;
      height: 100%;
    }
  }
}

.wx-submit {
  padding: 12px 16px 10px 16px;
  background-color: #fff;
  margin-top: -12px;
  .submit {
    width: 100%;
    height: 48px;
    display: block;
    text-align: center;
    line-height: 48px;
    background: linear-gradient(270deg, #ff7c39 0%, #ffb15c 100%);
    border-radius: 26px;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 48px;
  }
}
}
.posterList{
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-around;
  align-content:flex-start;
  .posterItem{
    display: block;
    width: 260px;
    margin-right: 28px;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .posterItem:nth-child(4n){
    margin-right: 0;
    
  }
}

.posterBox{
  position: relative;
  .posterCont_h1{
      // background-color: #000;
      // border-radius: 20px;
      // display: flex;
      // flex-wrap: wrap;
      // justify-content: flex-start;
      // align-items: center;
      width: 100%;
    .pic1{
      display: block;
      width: 100%;
      min-height: 100px;
    }
    .h1_cont{
      background-color: #ffffff99;
      border-radius: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
      position: absolute;
      bottom: 20px;
      left: 5%;
      width: 90%;


      .pic2{
        width: 80px!important;
        height: 80px!important;
      }

      .avatar-uploader{
        width: 80px!important;
        height: 80px!important; 

      }
      .cont_r{
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        margin-left:20px;  
        font-size: 20px;
        width: 190px;
        cursor: pointer;

        .phone{
          
          background-color:#f7f8fb00;
          line-height:40px;
        }

        .el-input{
          width:160px;
          background-color:#f7f8fb00;
          line-height:40px;

          /deep/.el-input__inner{
            background-color:#f7f8fb00;

          }
        }

      }
    }
    
  }
  .posterCont_h2{
      border: 1px solid #ddd;
      padding: 20px;
      margin-top: 20px;
      background: #fff;
    .h2_title{
      text-align: center;
      margin-bottom: 10px;
      font-size: 14px;
      font-weight: bold;
    }
    .h2_cont{
      display: flex;
      flex-wrap: wrap;
      align-content: space-between;
      justify-content:space-between;
      .h2_item{
        width: 25%;
        background-color: #e8eaec;
        padding: 10px;
        cursor: pointer;   
        border-radius: 8px;

        .item_title{
          text-align: center;
          margin-bottom: 5px;
          font-size: 14px;
          font-weight: bold;
          color:#333;
        }
        .item_cont{
          text-align: left; 
          font-size: 14px; 
          text-align:center;
        }
      }
      .act{
        background-color:#a7abae;
        .item_title{
          color:#846FFD;
        }
        .item_cont{
          color:#846FFD;
        }
      }
    }
  }
  .posterCont_h3{
    margin-top:20px;
    text-align:center;
  }
  .posterCont_h4{
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 5% 5% 20% 5%;
    width: 90%;
    background-color: #f2f3f5;
    border-top: 1px solid #ddd;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;

    .phoneBox_h1{ 
      display: flex;
      justify-content: space-between;
      margin-bottom: 35px;
      .btnl {
        font-size: 14px;
        color: #999fb5;
      }
      .btnNane {
        font-size: 18px;
        color: #191b27;
        font-weight: 600;
      }
      .btnr {
        font-size: 14px;
        color: #846ffd;
      }
    }

    .phoneBox_h2{ 
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .el-icon-phone{
        display: block;
        line-height: 40px;
        margin-right: 10px;
      }
      .el-input{
        width: 270px;
      }
    }
  }
}

/deep/.avatar-uploader .el-upload{
        width: 80px!important;
        height: 80px!important; 
        border:none;
    }
.picEdit{ 
      display:inline-block;
      width: 80px!important;
      height: 80px!important; 
      border:none;
}
.qrCodeEdit{
      display:inline-block;
      width: 80px!important;
      height: 80px!important; 
      border:none;
}
</style>
